export default function ActiveGaps({
  events
}) {

  const allGaps = [];

  events.forEach(event => {
    event.gaps.forEach(gap => {
      allGaps.push({
        ...gap,
        clause_title: event.clause.title
      });
    });
  });

  const highRisk = allGaps.filter(
    gap => gap.severity === "high"
  );

  const mediumRisk = allGaps.filter(
    gap => gap.severity === "medium"
  );

  return (
    <div className="bg-white border rounded-xl p-6 shadow-sm">

      <div className="flex items-center justify-between mb-4">

        <div className="text-xl font-semibold">
          Active Gaps
        </div>

        <div className="text-sm text-gray-500">
          {allGaps.length} unresolved items
        </div>

      </div>

      {/* High Risk */}

      {highRisk.length > 0 && (
        <div className="mb-6">

          <div className="text-red-600 font-semibold mb-3">
            High Risk
          </div>

          <div className="space-y-3">

            {highRisk.map((gap, idx) => (
              <div
                key={idx}
                className="
                  border
                  border-red-200
                  bg-red-50
                  rounded-lg
                  p-3
                "
              >

                <div className="font-medium">
                  {gap.message}
                </div>

                <div className="text-sm text-gray-500 mt-1">
                  {gap.clause_id}
                </div>

              </div>
            ))}

          </div>

        </div>
      )}

      {/* Medium Risk */}

      {mediumRisk.length > 0 && (

        <div>

          <div className="text-yellow-700 font-semibold mb-3">
            Medium Risk
          </div>

          <div className="space-y-3">

            {mediumRisk.map((gap, idx) => (
              <div
                key={idx}
                className="
                  border
                  border-yellow-200
                  bg-yellow-50
                  rounded-lg
                  p-3
                "
              >

                <div className="font-medium">
                  {gap.message}
                </div>

                <div className="text-sm text-gray-500 mt-1">
                  {gap.clause_id}
                </div>

              </div>
            ))}

          </div>

        </div>
      )}

    </div>
  );
}